module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./giud.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/giud.md
// module id = K7yA
// module chunks = 0